// extracted by mini-css-extract-plugin
export var button = "_5n-0";
export var icon = "_5n-1";